/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';
import {
  Paper,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import useStyle from './useStyle';
import FeaturesFlagTable from './components/DataTable/FeaturesFlagTable';
import newButton from '../../assets/img/iconos/newButton.svg';
import searchIcon from '../../assets/img/iconos/searchIcon.svg';
import ActionForm from './components/ActionForm/ActionForm';
import {
  getFeaturesFlagService,
} from '../../services';

const PersonFeaturesFlagScreen = () => {
  const classes = useStyle();
  const [featuresFlag, setFeaturesFlag] = useState([]);
  const [enteredFilter, setEnteredFilter] = useState('');
  const defaultData = {
    name: '',
    code: '',
    description: '',
    url: '',
  };
  const [defaultValues, setDefaultValues] = useState(defaultData);
  const [popUpAction, setPopUpAction] = useState({ open: false, title: '', data: null });
  const getFeaturesFlag = async () => {
    const res = await getFeaturesFlagService();
    return setFeaturesFlag(res?.data);
  };

  const createFeaturesFlag = () => {
    setDefaultValues(defaultData);
    setPopUpAction({
      open: true,
      title: 'Crear Feature Flag',
      data: null,
    });
  };

  useEffect(() => {
    getFeaturesFlag();
  }, []);

  return (

    <Paper className={classes.paper}>
      <>
        <div className={classes.root}>
          <div>
            <TextField
              className={classes.searchTextField}
              value={enteredFilter}
              onChange={(e) => setEnteredFilter(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} alt="searchIcon" style={{ paddingLeft: '10px' }} />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              placeholder="Buscar"
            />
            <Tooltip title="Crear Feature Flag" aria-label="Nuevo Feature Flag">
              <IconButton
                onClick={createFeaturesFlag}
                style={{ fontSize: '20px', float: 'right' }}
                edge="end"
                size="small"
                classes={{ disabled: classes.disabled }}
              >
                <img src={newButton} alt="newButton" />
              </IconButton>
            </Tooltip>
          </div>
          <FeaturesFlagTable
            setFeaturesFlag={setFeaturesFlag}
            featuresFlag={featuresFlag}
            setDefaultValues={setDefaultValues}
            enteredFilter={enteredFilter}
            setPopUpAction={setPopUpAction}
          />
          <ActionForm
            open={popUpAction.open}
            data={popUpAction.data}
            title={popUpAction.title}
            defaultValues={defaultValues}
            getFeaturesFlag={getFeaturesFlag}
            onClose={() => {
              setPopUpAction({ open: false, title: '', data: null });
            }}
          />
        </div>
      </>
    </Paper>
  );
};

export default PersonFeaturesFlagScreen;
